import { useQuery } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";
import { Profile } from "../types";

const fetchProfile = async (userId: string): Promise<Profile> => {
  const { data, error } = await supabase
    .from("profiles")
    .select("id, name, created_at, updated_at")
    .eq("id", userId)
    .single();

  if (error) {
    throw new Error(error.message || "Failed to fetch profile");
  }

  if (!data) {
    throw new Error("Profile not found");
  }

  return {
    id: data.id,
    name: data.name,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
};

export const useGetProfile = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["profile", userId],
    queryFn: () => {
      if (!userId) {
        throw new Error("User ID is required");
      }
      return fetchProfile(userId);
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
  });
};
